module.exports = __webpack_public_path__ + "img/burkina-faso-logo-icon.7d64b3bd.png";